// extracted by mini-css-extract-plugin
export var change = "_37-1";
export var changeList = "_37-0";
export var changePath = "_37-2";
export var diffArrow = "_37-5";
export var diffRow = "_37-3";
export var diffValue = "_37-4";
export var error = "_37-8";
export var notice = "_37-9";
export var result = "_37-6";
export var success = "_37-7";